<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
  .modal-body {
    padding: 0 1rem;
  }
</style>

<style scoped>
  .form-control{
    border: none;
    background: #eee;
    font-size: 1.2em;
    color: #000;
  }

  textarea{
    resize: none;
  }
</style>

<style>
  .multiselect__tags {
    background: #f0f0f0;
    color: #000;
  }
</style>
<template>
  <form @submit="updateRole">
    <b-modal title="Edit Role Details" :visible="roleId !== null"
      @ok="close" @cancel="close" @hide="close">
      <p :class="{'text-muted': !createRoleError, 'text-danger': createRoleError}">
        {{ !createRoleError ? '' : 'Failed to create role' }}
      </p>

      <div class="form-group mb-3">
        <label for="name">Role Name</label>
        <input id="name" v-model="name" type="text" class="form-control" required />
      </div>

      <div class="form-group mb-4">
        <label for="description">Role Description</label>
        <textarea
          id="description"
          class="form-control"
          v-model="description"
          type="description"
          rows="5"
          required />
      </div>

      <template slot="modal-footer">
        <div class="row justify-content-end pb-0">
          <div class="px-3">
            <button @click="updateRole" type="submit" :class="{disabled: creatingRole}" class="btn btn-primary px-4">
              {{ !creatingRole ? 'SUBMIT' : 'Please Wait...' }}
            </button>
          </div>
        </div>
      </template>
    </b-modal>
  </form>
</template>

<script>
  import { mapState } from 'vuex';

  export default {
    name: 'EditRole',
    props: {
      roleId: {
        type: String,
        required: true
      }
    },
    mounted(){
      if(!this.roles){
        this.$store.dispatch('getRoles');
        this.$store.subscribe(mutation => {
          if(mutation.type === 'SET_ROLES')
            this.$store.dispatch('setRoleBeingEdited', this.roleId);
        });
      }
      else
        this.$store.dispatch('setRoleBeingEdited', this.roleId);
    },
    beforeDestroy(){
      this.$store.dispatch('setRoleBeingEdited', null);
    },
    data(){
      return {
        name: '',
        description: ''
      }
    },
    computed: {
      ...mapState(['roleBeingEdited', 'creatingRole', 'createRoleError'])
    },
    watch: {
      roleBeingEdited: function(role){
        if(!role)
          return;

        this.name = role.name;
        this.description = role.description;
      }
    },
    methods: {
      close(){
        this.$router.replace('/userAccess/roles/');
      },
      updateRole(e){
        if(e && e.preventDefault)
          e.preventDefault();
          
        if(!this.roleBeingEdited)
          return;

        const data = {
          _id: this.roleBeingEdited._id,
          name: this.name,
          description: this.description,
        }
        this.$store.dispatch('updateRole', {data, rolePermissions: this.roleBeingEdited.rolePermissions});
      }
    }
  }
</script>
